<script setup lang="ts">
import type { CSSProperties } from 'vue'
import type { NovaBoxContentsDetailPageProps } from './NovaBoxContentsDetailPage.types'

const props = withDefaults(defineProps<NovaBoxContentsDetailPageProps>(), {
  title: '',
  responsive: () => ({
    mobile: { padding: '20px 0 60px 0' },
    tablet: { padding: '20px 0 60px 0' },
    desktop: { padding: '20px 0 60px 0' },
  }),
  gap: 20,
  isScrollToContentsOnMounted: false,
})

const { gtEvent } = useGoogleTag()
const layoutStore = useLayoutStore()
const { responsive } = storeToRefs(layoutStore)
const contentsDetailPageRef = ref<HTMLElement>()
const pageStyles = computed<CSSProperties>(
  () => props.responsive[responsive.value]
)
const headerStyles = computed<CSSProperties>(() => ({
  marginBottom: useGetStyleSize(props.gap),
}))

onMounted(async () => {
  await nextTick()
  await useSleeper(300)
  if (props.isScrollToContentsOnMounted && contentsDetailPageRef.value) {
    window.scrollTo(0, contentsDetailPageRef.value?.offsetTop)
  }
})

const sendGaEvent = () => {
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: '뒤로 가기 버튼 클릭',
    eventLabel: 'arrow-left',
    eventSlot: `${props.title} > 헤더`,
    eventI18nAddr: 'arrow-left',
    eventComponent: 'Button',
  })
}
</script>

<template>
  <div
    ref="contentsDetailPageRef"
    class="contents-detail-page"
    :style="pageStyles"
  >
    <div class="contents-detail-page-header" :style="headerStyles">
      <div class="left-area" @click.stop="sendGaEvent">
        <NovaButtonIcon
          :icon="{ type: 'outline', name: 'arrow-left' }"
          @click="
            () => {
              goBack ? goBack() : useNavigations({ type: 'back' })
            }
          "
        />
        <h4 v-if="title" v-dompurify-html="title" class="title" />
      </div>
    </div>

    <slot />
  </div>
</template>

<style scoped lang="scss">
.contents-detail-page {
  display: flex;
  flex-direction: column;

  .contents-detail-page-header {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 40px;

    .left-area {
      display: flex;
      align-items: center;
      gap: 6px;

      .title {
        @include text-style($text-heading3-bold);
      }
    }
  }
}
</style>
